module.exports = __webpack_public_path__ + "img/code-Inspection.ebe88a56.jpg";